<ion-app>
  <ion-router-outlet id="content1"></ion-router-outlet>
  <oms-menu *ngIf="menuVisible && initialized"></oms-menu>
  <oms-environment *ngIf="initialized"></oms-environment>
  <job-preview-stamp></job-preview-stamp>
</ion-app>
